import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import * as React from 'react';

import { cn } from '@shared/utils/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, name, ...props }, ref) => {
  // Prioriza data-testid explícito; si no, deriva del name (formularios).
  const derivedFromName = name ? name.split('.').join('-').replace('*-', '') : undefined;

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      name={name}
      className={cn(
        'peer h-4 w-4 shrink-0 rounded-sm border border-card-border bg-background shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-card-border data-[state=checked]:text-icons light:data-[state=checked]:border-primary light:data-[state=checked]:bg-background light:data-[state=checked]:text-primary',
        className,
      )}
      {...props}
      data-testid={props['data-testid'] ?? derivedFromName}
    >
      <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
        <Check className="!h-3.5 !w-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
